import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Dialog, RaisedButton, MenuItem } from 'material-ui';

import {reduxForm, Field, SubmissionError, formValueSelector} from 'redux-form';
import { TextField, SelectField, Checkbox } from 'redux-form-material-ui';

import { updateBackendNotification } from 'sagas/notifications/backendNotifications';
import { length, required, format } from 'redux-form-validators';

import { execute } from 'store/configureStore';
import {formName} from "../../data/formNames";
import _ from 'lodash';

const platforms = ['iOS', 'Android', 'All'];

const styles = {
    dialog: {
        contentStyle: {width: '300px', padding: '18px'},
    },
    textField: {
        floatingLabelStyle: { fontSize: '12px' },
    },
    raisedButton: {
        style: { background: '#7FC931' },
    },
    icon: { color: '#CBCBCB' },
    message: {
        style: { maxHeight: '192px', overflowY: 'scroll' }
    }
};

// import { createBackendNotification } from 'actions/notifications/backendNotifications';

class CreateBackendNotification extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { open, toggle } = this.props;

        return (
            <Dialog
                title='Do you want to create notification?'
                modal={false}
                open={open}
                onRequestClose={toggle}
            >
                <form onSubmit={this.props.handleSubmit}>
                    <div className="row">
                        <div className="col-xs-6">
                            <Field
                                component={SelectField}
                                name='platform'
                                floatingLabelText='Platform'
                                floatingLabelStyle={styles.textField.floatingLabelStyle}
                                autoWidth
                                fullWidth
                                validate={required()}
                            >
                                {
                                    platforms.map((platform, index) => {
                                        return (<MenuItem
                                            key={index}
                                            value={platform}
                                            primaryText={platform} />)
                                    })
                                }
                            </Field>
                        </div>
                        <div className='col-xs-6'>
                            <Field
                                component={TextField}
                                name='actualVersion'
                                floatingLabelText='ActualVersion'
                                fullWidth
                                floatingLabelStyle={styles.textField.floatingLabelStyle}
                                validate={[
                                    required({
                                        if: (values) => {
                                            return values.platform !== 'All';
                                        }
                                    }),
                                    format({
                                        if: (values) => {
                                            return values.platform !== 'All';
                                        },
                                        with: /(?:0|[1-9]\d*)\.(?:0|[1-9]\d*)\.(?:0|[1-9]\d*)/,
                                        message: 'format must be 0.0.0'
                                    })
                                ]}
                            />
                        </div>
                    </div>

                    <div className='row'>
                        <div className="col-xs-12" style={styles.message.style}>
                            <Field
                                component={TextField}
                                name='message'
                                floatingLabelText='Message'
                                fullWidth
                                multiLine
                                rows={6}
                                floatingLabelStyle={styles.textField.floatingLabelStyle}
                                validate={[ required({ }), length({ min: 5, max: 1024}) ]}
                            />
                        </div>
                    </div>


                    <div className='row'>
                        <div className="col-xs-6">
                            <Field
                                component={Checkbox}
                                name='requiredUpdate'
                                label='Required Update'
                            />
                        </div>
                        <div className="col-xs-6">
                            <Field
                                component={Checkbox}
                                name='show'
                                label='Show'
                            />
                        </div>
                    </div>

                    <RaisedButton
                        label='Cancel'
                        primary
                        onClick={toggle}
                    />

                    <RaisedButton
                        label='Save'
                        type='submit'
                        style={styles.raisedButton.style}
                    />
                </form>
            </Dialog>
        );
    }
}

const handleSubmit = async (values, dispatch, props) => {
    values = _.cloneDeep(values);

    const response = await execute(updateBackendNotification, values);

    if (response.status !== 200) {
        let errors = {};

        response.errors.forEach((error) => {
            errors = _.merge(errors, _.set({}, error.field, error.messages[0]));
        });

        throw new SubmissionError(errors);
    }

    props.toggle();
};

const MyForm = reduxForm({
    form: 'notifications/update',
    enableReinitialize: true,
    onSubmit: handleSubmit,
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: true,
})(CreateBackendNotification);

export default connect(
    ({ backendNotifications }, props) => {
        return {
            initialValues: { ...backendNotifications.items.find((item) => item._id === props.updateId) },
        };
    },
    dispatch => bindActionCreators({}, dispatch),
)(MyForm);



// WEBPACK FOOTER //
// ./app/components/BackendNotifications/Update.jsx